import { create } from 'zustand';

export const useMyViewsControlTower = create((set) => ({
  data: [],
  setData: (data: any) => set(() => ({ data: data })),
  clearData: () => set({ data: [] })
}));

export const useControlTowerData = create((set) => ({
  data: [],
  setData: (data: any) => set(() => ({ data: data })),
  clearData: () => set({ data: [] })
}));
